import * as actionTypes from "./constants";

export const checkRoom = room => ({
  type: actionTypes.CHECK_ROOM,
  room
});
export const uncheckRoom = room => ({
  type: actionTypes.UNCHECK_ROOM,
  room
});

export const setSelectedKeyword = keyword => ({
  type: actionTypes.SET_SELECTED_KEYWORD,
  keyword
});

export const setAvailableKeyword = keyword => ({
  type: actionTypes.SET_AVAILABLE_KEYWORD,
  keyword
});

export const selectRooms = rooms => ({
  type: actionTypes.SELECT_ROOMS,
  rooms
});

export const deselectRooms = rooms => ({
  type: actionTypes.DESELECT_ROOMS,
  rooms
});



// WEBPACK FOOTER //
// ./src/cleaning/schedule/roomPicker/actions.js